import pages from "../../Pages.json";
import IQACDynamicPage from '../../DynamicPage/IQACDynamicPage';
import TableComponent from '../../../components/Table/TableComponent';
import "./StaffCouncil.scss";

const StaffCouncil = () => {

    const staffCouncil = pages['staff-council'][0];
    const columns = ["S.No.", "Name", "Designation & Department", "Email ID"];
    const rows = [
        { name: "Dr. R. Marimuthu", DesignationDepartment: "Principal & Head, Department of Commerce (PG)", emailid: "nicollege2001@yahoo.co.in" },
        { name: "Dr. R. Rajalakshmi", DesignationDepartment: "Asst. Prof. &  Head, Department of Computer Science",  emailid: "rajalakshminatesh@gmail.com" },
        { name: "Mrs. S. T.  Deepa", DesignationDepartment: "Asst. Prof. &  Head, Department of Information Technology" , emailid: "deepapramod1972@gmail.com" },
        { name: "Dr. R. P. Dhanya", DesignationDepartment: "Asst. Prof. &  Head, Department of Microbiology" , emailid: "rpdhanyasunil@gmail.com" },
        { name: "Dr. D. Sophin Seeli", DesignationDepartment: "Asst. Prof. &  Head, Department of Computer Application", emailid: "sophinseeli@gmail.com" },
        { name: "Dr. V. S. Sangeetha", DesignationDepartment: "Asst. Prof. &  Head, Department of Biotechnology (PG)" , emailid: "sangeegodwin@gmail.com" },
        { name: "Dr. M. P. Anupa", DesignationDepartment: "Asst. Prof. &  Head, Department of Biotechnology (UG)" , emailid: "anupriya15@gmail.com" },
        { name: "Dr. Ciby S. Kumar", DesignationDepartment: "Asst. Prof. &  Head, Department of Visual Communication" , emailid: "cibys80@gmail.com" },
        { name: "Mr. B. Sankar Gopu", DesignationDepartment: "Asst. Prof. &  Head, Department of Computer Science (UG)" , emailid: "bsankargopu1974@gmail.com" },
        { name: "Ms. S. Mohamed Murshitha", DesignationDepartment: "Asst. Prof. &  Head, Department of English (PG)" , emailid: "murishitha@yahoo.co.in" },
        { name: "Mr. T. Janardhanan", DesignationDepartment: "Asst. Prof. &  Head, Department of English (UG)" , emailid: "maghil.jana2015@yahoo.co.in" },
        { name: "Dr. J. Babudhas", DesignationDepartment: "Asst. Prof. &  Head, Department of commerce (UG)" , emailid: "babudhasj31@gmail.com" },
        { name: "Dr. C. Murugesan", DesignationDepartment: "Asst. Prof. &  Head, Department of Maths (PG)" , emailid: "kumarithozhanmurugesan@gmail.com" },
        { name: "Dr. T. Shining Vinil Priya", DesignationDepartment: "Asst. Prof. &  Head, Department of Chemistry" , emailid: "Shinysuresh87@gmail.com" },
        { name: "Dr. S. G. Sugitha", DesignationDepartment: "Asst. Prof. &  Head, Department of Business Administrations." , emailid: "sugithaammu2392@gmail.com" },
        { name: "Dr. U. Josephine Benedit Bai", DesignationDepartment: "Asst. Prof. &  Head, Department of  Nutrition & Dietetics" , emailid: "sharewithjosephin @gmail.com" },
        { name: "Mr. S. Mohanshas", DesignationDepartment: "Asst. Prof. &  Head, Department of Hotel Management & Catering Science" , emailid: "dhasmohan777@gmail.com" },
        { name: "Dr. J. John Arul Singh", DesignationDepartment: "Asst. Prof. &  Head, Department of Mathematics" , emailid: "arulsinghmaths@yahoo.co.in" },
        { name: "Dr. R. Kavitha Rani ", DesignationDepartment: "Asst. Prof. &  Head, Department of Mathematics" , emailid: "kavithar480@gmil.com" }
    ];

    return (
        <section className="staffCouncilMainContainer">
            <article className="firstSection">
                <IQACDynamicPage
                    title={staffCouncil.title}
                    content={staffCouncil.content}
                    secondtitle={staffCouncil.secondtitle}
                />

                <article className='points-style'>
                    <ol className='points-ol-list'>
                        <li>Approving and revising academic programs, syllabus, and course structures.</li>
                        <li>Overseeing the implementation of new educational initiatives.</li>
                        <li>Developing and implementing policies on faculty welfare, leave, and workload</li>
                        <li>Recommending changes to institutional rules and regulations.</li>
                        <li>Reviewing student discipline, attendance, and grievances.</li>
                        <li>Monitoring co-curricular and extracurricular activities.</li>
                        <li>Planning Faculty Development Programs (FDPs), workshops, and seminars</li>
                        <li>Promoting research activities and academic growth.</li>
                        <li>Assisting in budget allocation and resource management.</li>
                        <li>Ensuring proper functioning of examination processes and evaluation systems.</li>
                        <li>Enhances faculty participation in institutional development.</li>
                        <li>Improves communication and transparency between administration and staff.</li>
                        <li>Strengthens the academic and administrative framework of the college.</li>
                    </ol>
                </article>

            </article>

            <article className="secondSection">
                <TableComponent
                    columns={columns}
                    data={rows}
                    title="Staff Council Members"
                    gap='10px'
                />
            </article>
        </section>
    )
}

export default StaffCouncil
